import React, {PropsWithChildren} from "react";
import styled from "@emotion/styled/macro";

const ViewTabItem: React.FC<PropsWithChildren & { active?: boolean, onClick: () => void }> = (props) => {
    return <p className={props.active ? "active" : ""} onClick={props.onClick}>{props.children}</p>
}
const ViewTabsDiv = styled.div`
height:48px;
  width:100%;
  display:flex;
  align-items: center;
  justify-content: space-around;
  p {
    height:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    color: var(--secondary-color);
    
  }
  .active {
    border-bottom: 1px solid var(--secondary-color);
  }
  
`;
export const ViewTabs: React.FC<{ viewTabs: string[], activeViewTab: string, onSetActiveViewTab: (tab: string) => void }> = (props) => {
    const {viewTabs, activeViewTab, onSetActiveViewTab} = props;
    return <ViewTabsDiv>
        {viewTabs.map(vt => <ViewTabItem active={vt === activeViewTab}
                                         onClick={() => onSetActiveViewTab(vt)}>{vt}</ViewTabItem>)}
    </ViewTabsDiv>
}